<template>
    <div class="section">
        <transactions-table></transactions-table>
        <delete-transaction-modal v-if="isDeleteModal"></delete-transaction-modal>
    </div>
</template>

<script>
    import TransactionsTable from "./TransactionsTable";
    import DeleteTransactionModal from "./DeleteTransactionModal";
    export default {
        components: {
            DeleteTransactionModal,
            TransactionsTable
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isDeleteModal() {
                return this.$store.getters.getTransactionDeleteModalStatus
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Banking/Transactions.vue